import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';

const CheckList = ({ items, selected, onChange }) => {
    const getStateFromProps = (props) => (props && props.map(x => x.toString())) || [];
    const [selectedState, setSelected] = useState(getStateFromProps(selected));

    useEffect(() => setSelected(getStateFromProps(selected)), [selected]);

    const handleChange = (e) => {
        const id = e.target.value;
        const newState = e.target.checked ? [...selectedState, ...[id]] : selectedState.filter(x => x.toLowerCase() !== id.toLowerCase());
        setSelected(newState);
        onChange && onChange(newState, e.target.checked, e.target.value);
    }

    const getItems = () => {
        const divs = [];
        let inputs = [];
        let divKey = 0;

        items.forEach((item, index) => {
            const id = (item.id && item.id.toString()) || item.toString();
            const key = `${id}_${index}`;
            const checked = selectedState.find(x => x.toString().toLowerCase() === id.toLowerCase()) ? true : false;

            if (inputs.length === 4) {
                divs.push(<div key={divKey} className='pe-1'>{inputs}</div>)
                divKey++;
                inputs = [];
            }

            inputs.push(
                <div>
                    <Input
                        type="checkbox"
                        key={key}
                        id={key}
                        checked={checked}
                        onChange={handleChange}
                        value={id}
                    />
                    <label for={key}>{item.description || item.name || id}</label>
                </div>
            );
        });

        if (inputs.length > 0)
            divs.push(<div key={divKey} className='pe-1'>{inputs}</div>)

        return divs;
    }

    return (
        <div className='checklist' >
            {getItems()}
        </div>
    );
}

export default CheckList